/* eslint-disable default-case */
import React, {   useContext } from "react";
import {
    Row,
    Col,
} from "../../ui/ot"
import { LibraryContext } from './library_context'
import SerialReceive from "../../cataloging/views/serial_receive";
const LibrarySerialReceive = ({
    user_permission_data=[]
}) => {
    const { branchcode, branchname } = useContext(LibraryContext);

    return (<Row gutter={[0, 0]}>
        <Col span={24}>
            <SerialReceive
             permission_level={user_permission_data?.map(group => group.permission_data.find(data => data.url.split("/").pop() === "serial_receive"))?.find(data => data !== undefined)?.permission_level_id ?? null}
                propsBranchcode={branchcode}
                conciseBibTitle
            />
        </Col>
    </Row>)
}

export default LibrarySerialReceive
